// @core/api/endpoints/attachment/get_download_url.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetDownloadUrlResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get presigned download URL
 * Generates a time-limited presigned URL for downloading the attachment directly from cloud storage. Supports inline or attachment content disposition.
 */
export async function GetDownloadUrl(
  attachment_id: string,
  options?: RequestOptions
): Promise<GetDownloadUrlResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id/download-url`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.get<GetDownloadUrlResponse>(requestPath, { ...requestOptions });
}
